export default "__VITE_ASSET__DRWeqEuf__"